<template>
    <div class="wrapper">
        <!-- 头图 -->
        <header>
            <img :src="ui.head" alt="头图" class="header_img"/>
        </header>
        <div :style="`backgroundColor:${ui.bg_color}`" ref="main" class="main_wrapper">
            <!-- 倒计时 -->
            <countDown v-if="ui.is_counter" :labelColor="ui.font_color"
                       :stime="stime"></countDown>
            <div class="form_wrapper" ref="form_wrapper">
                <!-- 表单部分 -->
                <van-form ref="actionForm">

                    <p class="vant_label" :style="`color:${ui.font_color} ? ${ui.font_color} : '#000'`">请输入姓名</p>
                    <van-field
                        v-model="action_form.name"
                        name="姓名"
                        placeholder="请输入姓名"
                    />
                    <p class="vant_label" :style="`color:${ui.font_color} ? ${ui.font_color} : '#000'`">请输入电话</p>
                    <van-field
                        type="tel"
                        v-model="action_form.phone"
                        name="电话"
                        placeholder="请输入电话"
                    />
                    <p class="vant_label" :style="`color:${ui.font_color} ? ${ui.font_color} : '#000'`"
                       v-if="is_city">请选择城市</p>
                    <van-field
                        v-if="is_city"
                        v-model="action_form.city"
                        is-link
                        readonly
                        placeholder="请选择城市"
                        @click="city_show = true"
                    />
                    <!-- todo 单选车型-->
                    <p class="vant_label" :style="`color:${ui.font_color} ? ${ui.font_color} : '#000'`"
                    >意向车型</p>
                    <van-radio-group v-model="action_form.brand" style="display: flex;flex-wrap: wrap">
                        <van-radio name="速腾">速腾</van-radio>
                        <van-radio name="迈腾">迈腾</van-radio>
                        <van-radio name="宝来">宝来</van-radio>
                        <van-radio name="高尔夫">高尔夫</van-radio>
                        <van-radio name="大众CC">大众CC</van-radio>
                        <van-radio name="T-ROC探歌">T-ROC探歌</van-radio>
                        <van-radio name="探岳">探岳</van-radio>
                        <van-radio name="迈腾GTE">迈腾GTE</van-radio>
                        <van-radio name="探岳GTE">探岳GTE</van-radio>
                        <van-radio name="宝来·纯电">宝来·纯电</van-radio>
                        <van-radio name="揽境">揽境</van-radio>
                        <van-radio name="探岳X">探岳X</van-radio>
                        <van-radio name="ID.4 CROZZ">ID.4 CROZZ</van-radio>
                        <van-radio name="ID.6 CROZZ">ID.6 CROZZ</van-radio>
                        <van-radio name="揽巡">揽巡</van-radio>
                        <van-radio name="ID.7 VIZZION">ID.7 VIZZION</van-radio>
                        <van-radio name="探影">探影</van-radio>

                    </van-radio-group>
                    <div class="policy_wrapper">
                        <zhongxin_policy @query="policy_check"></zhongxin_policy>
                    </div>
                    <div>
                        <div
                            class="form_item_btn able_btn"
                            round v-if="!is_stop" @click="submitForm"
                            :style="`backgroundColor: ${ui.btn_bg_color};color: ${ui.btn_font_color}`">
                            {{ui.btn_text}}
                        </div>
                        <van-button class="form_item_btn"
                                    type="info" round v-if="is_stop" :disabled="true">活动已结束
                        </van-button>
                    </div>
                </van-form>
            </div>
            <!-- 走马灯-->
            <banner v-if="ui.is_banner"></banner>
        </div>
        <div class="detail_img" :class="ui.is_copyright ? '' : 'pb_20'">
            <!-- 详情图-->
            <img :src="ui.tail" alt="详情图" class="detail_img" ref="tailImage"/>
        </div>
        <!-- 版权-->
        <div>
            <copyright v-if="ui.is_copyright"></copyright>
        </div>
        <div v-if="btn_show" class="footer_wrapper">
            <div class="bottom_btn"
                 @click="btn_click_form"
                 :style="`backgroundColor: ${ui.btn_bg_color};color: ${ui.btn_font_color}`">
                {{ui.btn_text}}
            </div>
        </div>

        <!-- 弹框部分-->
        <!-- 报名成功弹框-->
        <el-dialog :visible.sync="is_success" v-if="is_success" class="Successful" width="50%">
            <el-result icon="success" title="报名成功"></el-result>
        </el-dialog>

        <!--  城市弹框-->
        <!-- :style="{height: '50%'}" :lock-scroll="false"-->
        <van-popup v-model="city_show" round position="bottom" :safe-area-inset-bottom="true">
            <!-- style="height: 100%;overflow-x: hidden;overflow-y: auto"-->
            <van-cascader
                v-model="cascaderValue"
                title="请选择所在地区"
                :options="citys"
                :fieldNames="cityNames"
                @close="city_show = false"
                @finish="finishCity"
            />
        </van-popup>
    </div>
</template>

<script>
    import countDown from "@/components/countDown";
    import policy from "@/components/policy";
    import zhongxin_policy from "@/components/zhongxin_policy";
    import copyright from "@/components/copyright";
    import banner from "@/components/banner";
    import _geturl from "@/utils/_geturl";
    import lib_activity from "@/libs/lib_activity";
    import lib_city from "@/libs/lib_city";
    import _wx from "@/common/_wx";
    import _time from "@/utils/_time";
    import _object from "@/utils/_object";
    import _regular from "@/utils/_regular";
    import lib_clue from "@/libs/lib_clue";
    import lib_success from "@/libs/lib_success";
    import cache_url from "@/cache/cache_url";
    import Toast from "vant/lib/toast";
    import _monitor from "@/monitor/_monitor";

    let action_form = {
        name: '', // 姓名
        phone: '', //电话
        city: '', //城市
        brand: '', //车型
    }

    export default {
        name: "common",
        components: {
            countDown,
            policy,
            copyright,
            banner,
            zhongxin_policy
        },
        data() {
            return {
                title: '', // document的title
                activity_id: 0, //活动ID
                tids: "", //模板ID
                channel: '', //渠道
                channel_name: '', //渠道名
                tid: 0, // 有无车型库
                share_theme: '', //分享描述
                stime: 0, // 项目开始时间
                etime: 0, // 项目结束时间
                ui: {
                    head: '', //头图
                    tail: '', //详情图
                    share: '', //分享图
                    bg_color: '', //表单背景色
                    font_color: '', //文本颜色
                    btn_bg_color: '', //按钮背景色
                    btn_font_color: '', //按钮文本颜色
                    btn_text: '', //按钮文本值
                    btm_btn_text: '', //底部按钮文本
                    is_banner: 0, //是否有轮播图
                    is_counter: 0, //是否有倒计时
                    is_copyright: 1, //协议
                    jmp_url: 0, //0-报名成功;1-帮朋友报名;2-置换二手车;3-邮寄门票
                },

                action_form: action_form,
                //城市联级选择
                citys: [], //城市数据
                cascaderProps: { //配置项
                    expandTrigger: 'hover', //展开方式
                    value: "id", //指定选项的值
                    label: "name", //指定选项标签
                    children: "children", //指定选项的子选项
                    emitPath: false, //该节点数组
                },


                is_success: false, //报名成功弹框
                is_city: false, //表单城市项，默认无城市
                is_stop: false, //活动是否已结束
                btn_show: false, //底部按钮显隐

                city_show: false,
                cascaderValue: '', //
                cityNames: {
                    text: 'name',
                    value: 'id',
                    children: 'children',
                },
                check: false, //选中状态

            }
        },
        created() {
            // 地址栏
            this.activity_id = _geturl("activity_id");
            this.tids = _geturl("tids");
            this.channel = _geturl("channel");
            this.channel_name = _geturl("channel_name");

            //获取项目信息
            lib_activity.info(this.activity_id, this.tids, this.init_info);

            //监测
            _monitor.init(this.channel, this.activity_id);
        },
        mounted() {
            // 监听页面滚动
            window.addEventListener('scroll', this.handleScroll, true)
        },
        beforeDestroy() {
            window.removeEventListener('scroll', this.handleScroll, true)
        },
        destroyed() {
            // window.removeEventListener('scroll', this.handleScroll())
        },
        methods: {
            //初始化项目信息
            init_info(data) {
                console.log(data)
                this.title = data.activity.theme;
                document.title = this.title;
                this.share_theme = data.activity.share_theme;
                this.etime = data.activity.etime;
                this.stime = data.activity.stime;
                this.tid = data.activity.tid;
                if(data.ui == null) {
                    this.ui = {};
                    return;
                }
                this.ui = data.ui;

                // 项目结束
                if (!data.activity.state || (_time._current() > data.activity.etime)) {
                    this.is_stop = true;
                    return;
                }

                // 判断是否有城市
                let city = []
                if (data.activity.city) {
                    city = data.activity.city.split(',');
                }
                if (city.length == 1 && city[0] > 0) {
                    //单城市项目
                    this.is_city = false;
                } else {
                    //多城市项目
                    this.is_city = true;
                    this.getCity(data.activity.city)
                }

                // 分享： ui存在再分享
                if (_object._length(this.ui) > 0) {
                    this.share();
                }
            },

            // 分享
            share() {
                let that = this;
                lib_activity.share(function (data) {
                    let options = {};
                    options.title = that.title;
                    options.desc = that.share_theme;
                    options.link = window.location.href;
                    options.image = that.ui.share;

                    _wx.js_api(data, _wx.share, options);
                })
            },


            // 加载城市
            getCity(city) {
                let that = this;
                lib_city.list(city, function (data) {
                    that.citys = data;
                })
            },

            // 必选协议
            policy_check(check) {
                this.check = check;
            },
            submitForm() {

                if (!this.action_form.name) {
                    Toast('请输入您的姓名');
                    return;
                }
                if(this.action_form.name && this.action_form.name.length>20) {
                    Toast('请输入正确的姓名');
                    return;
                }
                if (!this.action_form.phone) {
                    Toast('请输入您的手机号');
                    return;
                }
                if (!_regular.is_mobile(this.action_form.phone)) {
                    Toast('请输入正确的手机号');
                    return;
                }
                if (this.is_city && !this.action_form.city) {
                    Toast('请选择城市');
                    return;
                }
                if(!this.action_form.brand) {
                    Toast('请选择车型');
                    return;
                }
                if(this.check == false) {
                    Toast('请勾选授权书');
                    return;
                }
                let cityArr = this.action_form.city.split('/'); // vant形式
                let location = this.is_city ? (cityArr[0] + '+' + cityArr[1]) : '';
                let url = window.location.href;
                let form_ui_id = this.ui.hasOwnProperty("id") ? this.ui.id : 0;
                let params = {
                    activity_id: this.activity_id,
                    channel_code: this.channel,
                    channel_name: this.channel_name,
                    url,
                    location,
                    form_name: this.action_form.name,
                    form_phone: this.action_form.phone,
                    form_brand: '',
                    form_series: this.action_form.brand,
                    form_ui_id,
                };
                let that = this;
                lib_clue.receive(params, function (data) {

                    //监测上报
                    _monitor.submit()

                    //缓存当页面链接
                    cache_url.set(window.location.href)
                    //跳转
                    // setTimeout(() => {
                    // }, 2000);
                    //不同参数跳转不同页面
                    const jmp_url = _object._length(that.ui) > 0 ? that.ui.jmp_url : 0
                    //跳转地址
                    const url = lib_success.jmp_url(jmp_url)
                    that.$router.push({
                        path: url,
                        query: {
                            id: data.id
                        },
                    })
                })
            },

            // 滚到表单开始部分
            btn_click_form() {
                let form_top = this.$refs.main.offsetTop - 50;
                document.documentElement.scrollTop = form_top
                document.body.scrollTop = form_top;
                document.querySelector('#app').scrollTop = form_top
            },
            // 滚动
            handleScroll() {
                let scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || document.querySelector('#app').scrollTop;
                this.$nextTick(() => {
                    if (scrollHeight >= this.$refs.tailImage.offsetTop) {
                        this.btn_show = true;
                    } else {
                        this.btn_show = false;
                    }
                })
            },
            finishCity({selectedOptions}) {
                this.city_show = false;
                this.action_form.city = selectedOptions.map((option) => option.name).join('/');
            },

        },
    };
</script>

<style lang="less" scoped>
    @import "../../assets/style/autoshow/base.less";
    @import "../../assets/style/autoshow/form.less";
    // form
    @import "../../assets/style/common/successful.less"; //报名成功
    @import "../../assets/style/autoshow/base_form.less";

    .van-radio{
        width: 50%;
        margin: 5px 0;
    }
    /deep/ .el-checkbox__inner{
        width: 36px;
        height: 36px;
    }
</style>